const Fan = require('graph-netecs/js/Fan').Fan;
const ObjectEvent = require('object-event').ObjectEvent;
const Pressure = require('graph-netecs/js/Pressure').Pressure;
const PowerOnShaft = require('graph-netecs/js/PowerOnShaft').PowerOnShaft;
const PolynomialLine = require('graph-netecs/js/PolynomialLine').PolynomialLine;
const Noise = require('graph-netecs/js/Noise').Noise;
const Constants = require('graph-netecs/js/Constants').Constants;
const GraphPoint = require('graph/js/Point').Point;
const Polynomial = require('mathFunctions/js/Polynomial').Polynomial;
const VerticalLine = require('graph-netecs/js/VerticalLine').VerticalLine;

/**
 * Zbiera to co jest wspólne dla fanGraph i fanSummary
 */
class fanAbstract {
    constructor(html, data, createGraphLine = true) {
        if (html) {
            this.html = html;//element html do którego zostaną wrzucone wykresy
            this.html.innerHTML = "";
        }

        this.createGraphLine = createGraphLine;

        this._moveRequestedPointToStart = () => {
        };
        this._moveRequestedPointToVeryFirstStart = () => {
        };
        this._moveRequestedPointTo = (workPointPerformance, workPointPerformanceHour, workPointPressure) => {
        };
        this.store = null;
        this.data = data;
        this.fan = new Fan();
        this.fanRecalced = new Fan();
        this.changed = ObjectEvent('changed');//event, który wywołujemy, gdy wewnatrz tej klasy zmienimy jakieś wartości, które wpisuje użutkownik (np. przeciągniemy ciśnienie i zmieni się częstotliwość) i wtedy trzeba przeliczyć wszystko
        this.canDraw = true;
        this.validityChanged = ObjectEvent('validityChanged');
        this.invalidValues = new Set();
        this.requestedPointEnabled = false;
        this.dragEventElementType = "";
        this.numberOfFans = 1;
    }

    get fanActive() {
        return this.fanRecalced;
    }

    /**
     * ustawia lini parametry, wedłóg których ma się przeliczyć
     * @private
     */
    _setRecalcParameters() {
        for (let line of Object.values(this.fan.lines)) {
            line.frequency = this.data.workPointBaseFrequency;
            line.density = this.data.workPointAirDensity;
            line.area = this.data.calcArea();
        }

        for (let line of Object.values(this.fanRecalced.lines)) {
            line.frequency = this.data.workPointFrequency;
            line.density = this.data.workPointAirDensity;
            line.area = this.data.calcArea();
        }
    }

    createInitialLines() {
        this.fan.number_of_fans = (this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : (this.numberOfFans ? this.numberOfFans : 1);
        
        this.fan.lines.TotalPressure = new Pressure('TotalPressure', [this.data.characteristic.TotalPressure.a0, this.data.characteristic.TotalPressure.a1, this.data.characteristic.TotalPressure.a2, this.data.characteristic.TotalPressure.a3], this.fan, this.fan.number_of_fans, this.data.workPointAboveSea, window.unitsList);
        this.fanRecalced.lines.TotalPressure = new Pressure('TotalPressure', [this.data.characteristic.TotalPressure.a0, this.data.characteristic.TotalPressure.a1, this.data.characteristic.TotalPressure.a2, this.data.characteristic.TotalPressure.a3], this.fanRecalced, this.fan.number_of_fans, this.data.workPointAboveSea, window.unitsList);

        this.fan.lines.PowerOnShaft = new PowerOnShaft('PowerOnShaft', [this.data.characteristic.PowerOnShaft.a0, this.data.characteristic.PowerOnShaft.a1, this.data.characteristic.PowerOnShaft.a2, this.data.characteristic.PowerOnShaft.a3], this.fan);
        this.fanRecalced.lines.PowerOnShaft = new PowerOnShaft('PowerOnShaft', [this.data.characteristic.PowerOnShaft.a0, this.data.characteristic.PowerOnShaft.a1, this.data.characteristic.PowerOnShaft.a2, this.data.characteristic.PowerOnShaft.a3], this.fanRecalced);

        this.fan.lines.Noise = new Noise('Noise', [this.data.characteristic.Noise.a0, this.data.characteristic.Noise.a1, this.data.characteristic.Noise.a2, this.data.characteristic.Noise.a3], this.fan, this.fan.number_of_fans);
        this.fanRecalced.lines.Noise = new Noise('Noise', [this.data.characteristic.Noise.a0, this.data.characteristic.Noise.a1, this.data.characteristic.Noise.a2, this.data.characteristic.Noise.a3], this.fanRecalced, this.fan.number_of_fans);

        this.fan.generateLines(this.createGraphLine);
        this.fanRecalced.generateLines(this.createGraphLine);

        let workPointPerformance = this.data.workPointPerformance;
        let workPointPerformanceHour = this.data.workPointPerformanceHour;
        let workPointPressure = this.data.workPointPressure;

        this._moveRequestedPointToVeryFirstStart = () => {
            this.data.workPointPerformance = workPointPerformance;
            this.data.workPointPerformanceHour = workPointPerformanceHour;
            this.data.workPointPressure = workPointPressure;

            this.changed.call(this);
        };

        this._moveRequestedPointToStart = () => {
            this.data.workPointPerformance = workPointPerformance;
            this.data.workPointPerformanceHour = workPointPerformanceHour;
            this.data.workPointPressure = workPointPressure;

            this.changed.call(this);
        };

        this._moveRequestedPointTo = (workPointPerformance, workPointPerformanceHour, workPointPressure) => {
            this.data.workPointPerformance = workPointPerformance;
            this.data.workPointPerformanceHour = workPointPerformanceHour;
            this.data.workPointPressure = workPointPressure;

            this.changed.call(this);
        };
    }

    _setValidity(inputName, isValid) {
        if (isValid) {
            if (this.invalidValues.has(inputName)) {
                this.invalidValues.delete(inputName);
                this.validityChanged.call(this, {inputName, isValid});
            }
        } else {
            if (!this.invalidValues.has(inputName)) {
                this.invalidValues.add(inputName);
                this.validityChanged.call(this, {inputName, isValid});
            }
        }
    }

    validateData() {
        this.canDraw = true;

        let values = {
            'workPointFrequency': {finite: true, nonZero: true},
            'range_min': {finite: true, nonZero: false},
            'range_max': {finite: true, nonZero: false},
            'outlet_area': {finite: true, nonZero: true},
            'inlet_area': {finite: true, nonZero: true},
            'workPointAboveSea': {finite: true, nonZero: false},
            'workPointTemperatureCelsius': {finite: true, nonZero: false},
            'workPointTemperature': {finite: true, nonZero: false},
            'workPointAirDensity': {finite: true, nonZero: true},
            'workPointAmount': {finite: true, nonZero: false},
            'workPointAmountUnit': {finite: true, nonZero: false},
            'workPointRotationSpeed': {finite: true, nonZero: true},
        };


        for (let curentName in values) {
            let current = values[curentName];
            let currentNumber = this.data[curentName];
            let currentValid = true;
            if (current.finite && !isFinite(currentNumber)) {
                currentValid = false;
                this.canDraw = false;
            }
            if (current.nonZero && currentNumber == 0) {
                currentValid = false;
                this.canDraw = false;
            }
            this._setValidity(curentName, currentValid);
        }

        if (this.data.range_min == this.data.range_max) {
            this.canDraw = false;

            this._setValidity('range_min', false);
            this._setValidity('range_max', false);
        } else {
            this._setValidity('range_min', isFinite(this.data.range_min));
            this._setValidity('range_max', isFinite(this.data.range_max));
        }

        for (let name in this.data.characteristic) {
            let currentCharacteristic = this.data.characteristic[name];
            let isValid = true;
            if ((!isFinite(currentCharacteristic.a0) || !isFinite(currentCharacteristic.a1) || !isFinite(currentCharacteristic.a2) || !isFinite(currentCharacteristic.a3)) ||
                (currentCharacteristic.a0 == 0 && currentCharacteristic.a1 == 0 && currentCharacteristic.a2 == 0 && currentCharacteristic.a3 == 0)) {
                isValid = false;
                this.canDraw = false;
            }
            this._setValidity(`characteristic[${name}][a0]`, isValid);
            this._setValidity(`characteristic[${name}][a1]`, isValid);
            this._setValidity(`characteristic[${name}][a2]`, isValid);
            this._setValidity(`characteristic[${name}][a3]`, isValid);

        }
    }

    /**
     * odświerza dane wprowadzone przez usera
     */
    refreshLines() {
        this.fan.number_of_fans = (this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : (this.numberOfFans ? this.numberOfFans : 1);

        this.fan.lines.TotalPressure.number_of_fans = this.fan.number_of_fans;
        this.fanRecalced.lines.TotalPressure.number_of_fans = this.fan.number_of_fans;
        this.fan.lines.DynamicPressure.number_of_fans = this.fan.number_of_fans;
        this.fanRecalced.lines.DynamicPressure.number_of_fans = this.fan.number_of_fans;
        this.fan.lines.StaticPressure.number_of_fans = this.fan.number_of_fans;
        this.fanRecalced.lines.StaticPressure.number_of_fans = this.fan.number_of_fans;
        this.fan.lines.StaticPressureIncrease.number_of_fans = this.fan.number_of_fans;
        this.fanRecalced.lines.StaticPressureIncrease.number_of_fans = this.fan.number_of_fans;


        this.fan.lines.TotalEfficiency.number_of_fans = this.fan.number_of_fans;
        this.fanRecalced.lines.TotalEfficiency.number_of_fans = this.fan.number_of_fans;
        this.fan.lines.StaticEfficiency.number_of_fans = this.fan.number_of_fans;
        this.fanRecalced.lines.StaticEfficiency.number_of_fans = this.fan.number_of_fans;

        this.fan.lines.PowerOnShaft.number_of_fans = this.fan.number_of_fans;
        this.fanRecalced.lines.PowerOnShaft.number_of_fans = this.fan.number_of_fans;
        this.fan.lines.Noise.number_of_fans = this.fan.number_of_fans;
        this.fanRecalced.lines.Noise.number_of_fans = this.fan.number_of_fans;
        this.fan.lines.PowerOnShaftWithMaterial.number_of_fans = this.fan.number_of_fans;
        this.fanRecalced.lines.PowerOnShaftWithMaterial.number_of_fans = this.fan.number_of_fans;

        this.fan.lines.TotalPressure.polynomialOriginal = new Polynomial([this.data.characteristic.TotalPressure.a0, this.data.characteristic.TotalPressure.a1, this.data.characteristic.TotalPressure.a2, this.data.characteristic.TotalPressure.a3]);
        this.fanRecalced.lines.TotalPressure.polynomialOriginal = this.fan.lines.TotalPressure.polynomialOriginal.clone();
        this.fan.lines.PowerOnShaft.polynomialOriginal = new Polynomial([this.data.characteristic.PowerOnShaft.a0, this.data.characteristic.PowerOnShaft.a1, this.data.characteristic.PowerOnShaft.a2, this.data.characteristic.PowerOnShaft.a3]);
        this.fanRecalced.lines.PowerOnShaft.polynomialOriginal = this.fan.lines.PowerOnShaft.polynomialOriginal.clone();

        this.fan.lines.Noise.polynomialOriginal = new Polynomial([this.data.characteristic.Noise.a0, this.data.characteristic.Noise.a1, this.data.characteristic.Noise.a2, this.data.characteristic.Noise.a3]);
        this.fanRecalced.lines.Noise.polynomialOriginal = this.fan.lines.Noise.polynomialOriginal.clone();

        this.fan.lines.PowerOnShaftWithMaterial.polynomialOriginal = this.fan.lines.PowerOnShaft.polynomialOriginal.clone();
        this.fanRecalced.lines.PowerOnShaftWithMaterial.polynomialOriginal = this.fan.lines.PowerOnShaft.polynomialOriginal.clone();

        this._setRecalcParameters();
        let densityDenominator = this.data.workPointAirDensityCalced;

        this.fan.lines.PowerOnShaft.density = (x) => {
            return this.data.workPointAirDensity
        };

        let workPointAirDensity = this.data.workPointAirDensity;
        let workPointAmount = this.data.workPointAmount;

        this.fan.lines.PowerOnShaftWithMaterial.density = (x) => {

            if (x == 0)
                return 1.2;

            return workPointAirDensity + workPointAmount / 3.6 / x / 1000
        };

        this.fan.lines.PowerOnShaftWithMaterial.densityDenominator = 1.2;
        this.fanRecalced.lines.PowerOnShaft.density = (x) => {
            return this.data.workPointAirDensity
        };
        this.fanRecalced.lines.PowerOnShaftWithMaterial.density = (x) => {
            if (x == 0)
                return 1.2;

            return this.data.workPointAirDensity + this.data.workPointAmount / 3.6 / x / 1000
        };

        this.fanRecalced.lines.PowerOnShaftWithMaterial.densityDenominator = 1.2;

        this.fan.lines.StaticPressure.area = this.data.calcArea();
        this.fanRecalced.lines.StaticPressure.area = this.data.calcArea();
        
        // NVS-131
        this.fan.lines.StaticPressureIncrease.area = this.data.calcArea();
        this.fanRecalced.lines.StaticPressureIncrease.area = this.data.calcArea();
        this.fan.lines.StaticPressureIncrease.inlet_area = this.data.calcInletArea();
        this.fanRecalced.lines.StaticPressureIncrease.inlet_area = this.data.calcInletArea();

        // NVS-144
        this.fan.lines.StaticPressure.workPointAboveSea = this.data.workPointAboveSea;
        this.fanRecalced.lines.StaticPressure.workPointAboveSea = this.data.workPointAboveSea;
        this.fan.lines.StaticPressure.units = window.unitsList;
        this.fanRecalced.lines.StaticPressure.units = window.unitsList;

        let oldLimit = this.data.range_limit;
        this.data.range_limit = this.fan.lines.StaticPressure.getZeroPoint(this.data.range_min) || NaN;

        if (isFinite(this.data.range_limit) && this.data.range_max === oldLimit)
            this.data.range_max = this.data.range_limit;

        // if (this.data.range_min > this.data.range_limit)
        //     this.data.range_min = 0;
        // if (this.data.range_min < 0)
        //     this.data.range_min = 0;

        // if (this.data.range_max < this.data.range_min)
        //     this.data.range_max = this.data.range_min;
        // if (this.data.range_max > this.data.range_limit)
        //     this.data.range_max = this.data.range_limit;

        this.fan.min = (this.data.range_min * (this.data.workPointBaseFrequency || Constants.frequency) / Constants.frequency) * (this.fan.number_of_fans ? this.fan.number_of_fans : 1);
        this.fan.max = (this.data.range_max * (this.data.workPointBaseFrequency || Constants.frequency) / Constants.frequency) * (this.fan.number_of_fans ? this.fan.number_of_fans : 1);
        this.fanRecalced.min = (this.data.range_min * (this.data.workPointFrequency || Constants.frequency) / Constants.frequency) * (this.fan.number_of_fans ? this.fan.number_of_fans : 1);
        this.fanRecalced.max = (this.data.range_max * (this.data.workPointFrequency || Constants.frequency) / Constants.frequency) * (this.fan.number_of_fans ? this.fan.number_of_fans : 1);

        for (let line of Object.values(this.fan.lines)) {
            line.min = this.fan.min;
            line.max = this.fan.max;
        }

        for (let line of Object.values(this.fanRecalced.lines)) {
            line.min = this.fanRecalced.min;
            line.max = this.fanRecalced.max;
        }
    }

    // NVS-27 - linia mocy zainstalowanej
    // szukamy takiego x dla którego wartość mocy na wale z materiałem jest równa mocy zainstalowanej
    // brak wzorów do odwrócenia przeliczenia funkcji wielomianowej sprawia, że musimy to liczyć z przybliżeniem
    // operacja wykonywana w tle
    async drawInstalledPowerLine(graph, line, dragEventElementType) {
        this.clearInstalledPowerLine(graph);
        if(this.store && this.store.state && this.store.state.activeFun.selectedFanData.motor_power == 'choice' && graph) {
            let ip = this.store.state.activeFun.params.installed_power;
            let x = null;
            if(line) {
                x = await line.getByY(ip, line.min, line.max)
                if(x) {
                    const ipLine = new VerticalLine(x, 'installedPower', '#a15410')
                    graph.addPoint(ipLine)
                    this.store.state.showPowerLine = true
                }
            }
        }
    }
    clearInstalledPowerLine(graph) {
        if(this.store && this.store.state) this.store.state.showPowerLine = false;
        if(graph) graph.points.filter(p => p.className == 'installedPower').forEach(p => graph.removePoint(p));
    }

    /**
     * tworzy charakterystyke instalacji
     * @private
     */
    _generateRequestedLine(forceToUseDenominator = false) {
        let _number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : (this.numberOfFans ? this.numberOfFans : 1));
        let max_number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.data && this.store.state.activeFun.data.number_of_fans) ?  this.store.state.activeFun.data.number_of_fans : (this.numberOfFans ? this.numberOfFans : 1));
        let denominator = 1;

        if(max_number_of_fans > _number_of_fans || forceToUseDenominator)
            denominator = max_number_of_fans;

        let requestedPressure = this.data.workPointPressure;
        let requestedPerformance = this.data.workPointPerformance;
        let isStatic = this.data.workPointPressureType === 'static';//total czy static


        if (this._requestedLine && this._requestedLine.isStatic !== isStatic) {
            this._clearRequestedLine();
        }
        if (!this._requestedLine) {
            this._requestedLine = new PolynomialLine('Requested');
            this._requestedLine.isStatic = isStatic;
            this._requestedLine.line.config.color = '#0088aa';
            this._requestedLine.chartScaling = false;
            this._requestedLine.showStartEndPoints = false;
        }
        this._requestedLine.polynomialOriginal = new Polynomial([0, 0, requestedPressure / Math.pow((requestedPerformance / denominator), 2)]);
    }

    /**
     * tworzy punkt z zapytania
     * @private
     */
    _generateRequestedPoint() {
        let _number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : (this.numberOfFans ? this.numberOfFans : 1));
        let max_number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.data && this.store.state.activeFun.data.number_of_fans) ?  this.store.state.activeFun.data.number_of_fans : (this.numberOfFans ? this.numberOfFans : 1));
        let denominator = 1;

        if(max_number_of_fans > _number_of_fans)
            denominator = max_number_of_fans;

        if (!this.requestedPoint) {
            this.requestedPoint = new GraphPoint((this.data.workPointPerformance / denominator), this.data.workPointPressure);
            this.requestedPoint.config = {projection: false};
            let startPerformance, startPressure;
            let _this_fanAbstract = this;

            this.requestedPoint.moved(e => {
                if (this.requestedPointEnabled) {
                    this.dragEventElementType = "requestedPoint";

                    if (e.moveType == 'start') {
                        startPerformance = e.x * denominator;

                        let axisY = null;

                        if(_this_fanAbstract.graph)
                            axisY = _this_fanAbstract.graph.getAxisByKind("pressure");
                        else if(_this_fanAbstract.requestedPoint)
                            axisY =  _this_fanAbstract.requestedPoint.parentPlane.ys;

                        startPressure = e.getByAxis(axisY);
                    }

                    this._moveRequestedPointToStart = () => {
                        this.data.workPointPerformance = this.Round(startPerformance, window.unitsList.performance.default_decimal_places);
                        this.data.workPointPerformanceHour = this.Round((startPerformance * 3600), window.unitsList.performance.default_decimal_places);
                        this.data.workPointPressure = this.Round(startPressure, window.unitsList.pressure.default_decimal_places);

                        this.changed.call(this);
                    };

                    if (e.isOnPlane) {
                        this.data.workPointPerformance = this.Round(e.x * denominator, window.unitsList.performance.default_decimal_places);
                        this.data.workPointPerformanceHour = this.Round((e.x * 3600 * denominator), window.unitsList.performance.default_decimal_places);
                        let axisY;

                        if (this.graph)
                            axisY = this.graph.getAxisByKind('pressure');
                        else
                            axisY = this.requestedPoint.parentPlane.ys;


                        this.data.workPointPressure = e.getByAxis(axisY);

                        this.changed.call(this);
                    } else {
                        this._moveRequestedPointToStart();
                    }


                    // if(!this._validateDragRestrictions())
                    //     this._moveRequestedPointToStart();
                }
            });

            let circle = this.requestedPoint.svgPoint.ownerDocument.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute('cx', 0);
            circle.setAttribute('cy', 0);
            circle.setAttribute('r', 4);
            circle.style.fill = '#ffffff';
            circle.style.cursor = '';
            circle.style.strokeWidth = '2px';
            circle.style.stroke = '#cccc00';
            this.requestedPoint.svgPoint.appendChild(circle);
        }

        this.requestedPoint.x = this.data.workPointPerformance / denominator;
        this.requestedPoint.y = this.data.workPointPressure;
    }

    /**
     * rysuje punkt maksymalnej sprawności
     * @param graph
     * @param line
     * @param x
     * @private
     */
    _drawMaxEfficiencyPoint(graph, line, x) {
        let _number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : (this.numberOfFans ? this.numberOfFans : 1));
        let _x = x;

        let y = line.fun(_x);
        if (!line.maxPoint) {
            line.maxPoint = new GraphPoint(_x, y);
            line.maxPoint.type = 'maxPoint';
            let circle = line.maxPoint.svgPoint.ownerDocument.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute('cx', 0);
            circle.setAttribute('cy', 0);
            circle.setAttribute('r', 4);
            circle.style.fill = '#cc00cc';
            line.maxPoint.svgPoint.appendChild(circle);
        }

        graph.addPoint(line.maxPoint);
        line.maxPoint.x = x;
        line.maxPoint.y = y;
        line.maxPoint.ys = line.line.ys;
    }

    /**
     * rysuje punkt pracy (przecięcia charakterystyki instalacji z ciśnieniem)
     * @param x
     * @param fan
     * @param line
     * @private
     */
    _drawWorkpoint(x, fan, line) {
        // let _number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : (this.numberOfFans ? this.numberOfFans : 1));
        // let max_number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.data && this.store.state.activeFun.data.number_of_fans) ?  this.store.state.activeFun.data.number_of_fans : (this.numberOfFans ? this.numberOfFans : 1));
        // let denominator = 1;
        //
        // if(max_number_of_fans > _number_of_fans)
        //     denominator = max_number_of_fans;

        if (!line.workPoint) {
            line.workPoint = new GraphPoint(x, line.fun(x));
            line.workPoint.type = 'workPoint';
            line.workPoint.config = {projection: true};
            let circle = line.workPoint.svgPoint.ownerDocument.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute('cx', 0);
            circle.setAttribute('cy', 0);
            circle.setAttribute('r', 4);
            circle.style.fill = '#006688';
            line.workPoint.svgPoint.appendChild(circle);
        }

        fan.addPoint(line.workPoint);
        line.workPoint.x = x;
        line.workPoint.y = line.fun(x);
        line.workPoint.ys = line.line.ys;
        line.workPoint.titleAsSVG = true;
        line.workPoint.titleLines = 2;

        if (line.line.xs)
            line.workPoint.title = `${line.line.xs.config.titleHTML}=&nbsp${line.line.xs.createValue(line.workPoint.x).display.format(3)} <br> ${line.line.ys.config.titleHTML}= ${line.line.ys.createValue(line.workPoint.y).display.format(3)}`;
        else
            line.workPoint.title = "";

        if (isFinite(line.workPoint.x) && isFinite(line.workPoint.y)) {
            line.workPoint.svg.style.display = 'block'
        } else {
            line.workPoint.svg.style.display = 'none'
        }
    }

    Round(n, k) {
        let factor = Math.pow(10, k);
        return Math.round(n * factor) / factor;
    }
}

export {fanAbstract};